module.exports = __webpack_public_path__ + "static/media/35_A.e24de664.png";